import React from "react";
import "./StatCard.css";

function StatCard({ label, value, unit, hint, icon: Icon, tone = "default" }) {
    return (
        <div className={`stat-card stat-card--${tone}`}>
            <div className="stat-card__head">
                <span className="stat-card__label uppercase-label">{label}</span>
                {Icon && (
                    <span className="stat-card__icon" aria-hidden="true">
                        <Icon size={14} />
                    </span>
                )}
            </div>
            <div className="stat-card__value mono-num">
                <span>{value}</span>
                {unit && <span className="stat-card__unit">{unit}</span>}
            </div>
            {hint && <div className="stat-card__hint">{hint}</div>}
        </div>
    );
}

export default StatCard;
